import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { CoordinatesShape } from 'constants/shapes';
import { Heading } from 'components/Heading/Heading';
import { Section } from 'components/Section/Section';
import { VenueCarousel } from 'components/VenueCarousel/VenueCarousel';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { selectIsMobile } from 'redux/modules/device';
import { selectUserLocation } from 'redux/modules/locale';
import { nearbyPopularVenues } from 'redux/saga/entities/bound';
import { filterValidVenues, loadVenues, nearbyVenuesKey, watchSaga } from './visitableVenues.saga';
import { VerticalVenueList } from './VerticalVenueList';

const MIN_DISPLAY_VENUES = 4;

export class VisitableVenuesUnwrapped extends Component {
  constructor(...args) {
    super(...args);
    this.handleCtaClick = this.handleCtaClick.bind(this);
  }

  componentDidMount() {
    const { coordinates } = this.props;
    this.props.loadVenues(coordinates);
  }

  componentDidUpdate(prevProps) {
    const coordinates = this.props.coordinates || {};
    const prevLocation = prevProps.coordinates || {};

    if (prevLocation.lat !== coordinates.lat || prevLocation.lon !== coordinates.lon) {
      this.props.loadVenues(coordinates);
    }
  }

  handleCtaClick() {
    segment.track('Studios Module', {
      action: 'Clicked Explore all studios',
    });
    ga('Studios Module', 'Clicked Explore all studios');
  }

  renderCarousel() {
    const { isClickable, venues } = this.props;
    return (
      <div className="venues__carousel">
        <VenueCarousel elements={venues} nolink={!isClickable} showCount />
      </div>
    );
  }

  renderList() {
    const { venues } = this.props;
    return (
      <div className="venues__list">
        <VerticalVenueList elements={venues} showCount />
      </div>
    );
  }

  render() {
    const { backgroundColor, extraClassNames, header, showAsList, subheader, venues } = this.props;

    return (
      venues.length >= MIN_DISPLAY_VENUES && (
        <div className={`bg--${backgroundColor || 'white'}`}>
          <Section className={classNames('venues', extraClassNames)}>
            <Heading className="venues__title">
              {header || <FormattedMessage id="visitable-venues.title" defaultMessage="Studios you can visit" />}
            </Heading>
            {subheader && <p className="venues__subtitle">{subheader}</p>}
            {showAsList ? this.renderList() : this.renderCarousel()}
            <div className="text--center">
              <Link to="/search" className="bt bt--primary bt--outline bt--lg" onClick={this.handleCtaClick}>
                <FormattedMessage id="visitable-venues.cta" defaultMessage="Explore all studios" />
              </Link>
            </div>
          </Section>
        </div>
      )
    );
  }
}

export const mapDispatchToProps = {
  loadVenues,
};

export const mapStateToProps = (state, props) => {
  const isMobile = selectIsMobile(state);
  const coordinates = props.coordinates || selectUserLocation(state);
  const { venues } = nearbyPopularVenues.data(state, nearbyVenuesKey(coordinates)) || { venues: [] };

  return {
    coordinates,
    showAsList: !!(isMobile && props.canShowVerticalViewInMobile),
    venues: filterValidVenues(venues),
  };
};

VisitableVenuesUnwrapped.propTypes = {
  backgroundColor: PropTypes.oneOf(['white', 'light']),
  coordinates: CoordinatesShape,
  extraClassNames: PropTypes.string,
  header: PropTypes.node,
  isClickable: PropTypes.bool,
  loadVenues: PropTypes.func.isRequired,
  showAsList: PropTypes.bool.isRequired,
  subheader: PropTypes.string,
  venues: PropTypes.array,
};

export const VisitableVenues = decorateWith(
  withSagas({ watch: watchSaga }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('VisitableVenues')
)(VisitableVenuesUnwrapped);

export default VisitableVenues;
